export let mp4Index: number

export const moveMp4ToFront = (
  arr: any,
  isMobile: boolean,
  setHeroBannerItems: (item: any) => void,
) => {
  let mp4
  const imageItems = arr.filter((item: any) => item.type === 'image')

  if (isMobile) {
    mp4 = arr.filter(
      (item: any) => item.type === 'mp4' && item.featured === false,
    )
  } else {
    mp4 = arr.filter(
      (item: any) => item.type === 'mp4' && item.featured === true,
    )
  }

  const bannerItems = [...mp4, ...imageItems]

  mp4Index = bannerItems.findIndex((item: any) => {
    return item.url.includes('.mp4')
  })

  if (mp4Index === -1) {
    setHeroBannerItems(bannerItems)
  }

  const [mp4Item] = bannerItems.splice(mp4Index, 1)

  bannerItems.unshift(mp4Item)

  setHeroBannerItems(bannerItems)
}
